import styled from 'styled-components';

export const Content = styled.span`
  position: relative;
  display: inline-block;
  padding-left: 36px;
  vertical-align: middle;

  svg {
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
`;
